<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->

                <div class="alertClass" id="success-alert">
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                            <!-- {{eventDetails}} -->
                        <!--First Name-->
                        <div class="col-6 forms-block">
                            <h1>{{ eventDetails.class_name }}</h1>
                        </div>
                        <div class="col-6 forms-block">
                            <!-- <h1 style="text-align:center;">{{ eventDetails.class_name }}</h1> -->
                            <template v-if="eventDetails.already_register == true && eventDetails.is_register">
                                <button v-show="showRegisterBtn" v-on:click="cancelRegistration()" class="form-control btn-danger">Cancel Registration</button>
                            </template>
                            <template v-else>
                                <button v-show="showRegisterBtn" v-on:click="registerToClass()" class="form-control btn-primary">Register</button>
                            </template>
                        </div>

                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label"><span style="font-weight: bold">Participation Cap :</span></div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <label class="form-label">{{ eventDetails.participation_cap }}</label>
                            </div>
                        </div>

                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label"><span style="font-weight: bold">Link :</span></div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <label class="form-label">{{ eventDetails.meeting_link }}</label>
                            </div>
                        </div>

                        <!--First Name-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" style="font-weight: bold">Class Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <label class="form-label">{{capitalizeFirstLetter(eventDetails.class_name) }}</label>
                            </div>
                        </div>

                        <!--Day of Week-->
                        <template  v-if="eventDetails.class_type === 'recurring' && eventDetails.recurring_type === 'weekly'">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" style="font-weight: bold">Day Of Week :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <label class="form-label">{{eventDetails.week_day }}</label>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="startTime" slot="before" style="font-weight: bold">Start Time :</div>
                                </div>
                                <div class="col-12 paddingleft0">
                                    <p>{{eventDetails.week_day_start_time}}</p>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="endTime" slot="before" style="font-weight: bold">End Time :</div>
                                </div>
                                <div class="col-12 paddingleft0">
                                    <p>{{eventDetails.week_day_end_time}}</p>
                                </div>
                            </div>
                        </template>

                        <!--Normal-->
                        <template v-if="eventDetails.class_type === 'normal'
                                            || (eventDetails.class_type == 'recurring' && eventDetails.recurring_type == 'monthly')
                                            || (eventDetails.class_type == 'recurring' && eventDetails.recurring_type == 'yearly')
                                            ">
                            <!--Date-->
                            <div class="col-12 forms-block d-flex justify-content-between">
                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="startDate" slot="before" style="font-weight: bold">Date :</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <p>{{eventDetails.start_date}}</p>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="startTime" slot="before" style="font-weight: bold">Start Time :</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <p>{{eventDetails.start_time}}</p>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="endTime" slot="before" style="font-weight: bold">End Time :</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <p>{{eventDetails.end_time}}</p>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!--Multipledate-->
                        <template v-if="eventDetails.class_type == 'multipledate'">
                            <template v-for="(input, index) in eventDetails.inputs">
                                <div class="col-12 forms-block d-flex justify-content-between">

                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="endTime" slot="before" style="font-weight: bold">Date</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <p>{{input.startDate}}</p>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="endTime" slot="before" style="font-weight: bold">Start Time</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <p>{{input.startTime.text}}</p>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="endTime" slot="before" style="font-weight: bold">End Time</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <p>{{input.endTime.text}}</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="clearfix"></div>
                        </template>

                        <!--Description-->
                        <template v-if="eventDetails.description != ''">
                        <div class="col-12 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" style="font-weight: bold">Description :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <div v-html="eventDetails.description" class="form-label"></div>
                            </div>
                        </div>
                        </template>

                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <!--Register-->
                    <template v-if="eventDetails.already_register == true && eventDetails.is_register">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group">
                                <!-- <button v-show="showRegisterBtn" v-on:click="cancelRegistration()" class="form-control btn-danger">Cancel Registration</button> -->
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </template>
                    <template v-else-if="eventDetails.is_class_full == true">
                        <p style="color: red">Sorry class is full!</p>
                        <button v-show="showRegisterBtn" v-on:click="registerToClass()" class="form-control btn-primary">Register ( {{eventDetails.waiting}} Waiting )</button>
                    </template>
                    <template v-else-if="eventDetails.attented == true">
                    </template>
                    <template v-else-if="eventDetails.dependent_class_not_attand == true">
                        <p style="color: red">You are not eligible for this class!</p>
                        <p style="color: red">You need to attand the {{eventDetails.dependent_class_not_attand_string}} classes.</p>
                    </template>
                    <div class="col-12 forms-block participant">
                        
                        <h1> Participant(s)</h1>
                        <template v-for="participant_user in eventDetails.participants">
                            <div class="col-12 forms-block">
                                {{ participant_user.name }}
                            </div>
                        </template>
                        
                    </div>
                    <!-- <div class="col-6 forms-block">
                        <h1>Dependent On</h1>
                            <template v-for="parent_class in eventDetails.dependent_on">
                                    <div class="col-12 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><span>{{ parent_class.name }} :</span></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <label class="form-label">{{ parent_class.meeting_link }}</label>
                                        </div>
                                    </div>
                            </template>
                    </div> -->
                    
                    
                    <template v-if="eventDetails.gallery_media">
                    <div class="row clearfix"></div>
                    <h1 style="text-align:center;">Already Uploaded Media</h1>
                    <div class="row mt-3">
                        <div class="col-md-4">
                            <div class="form-group bold">
                                Name
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group bold">
                                Description
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group bold text-center">
                                Media
                            </div>
                        </div>
                    </div>
                    <template v-for="(media,index) in eventDetails.gallery_media">
                        <div class="row bulletin-board-listing">
                            <div class="col-md-4">
                                <div class="form-group">
                                    {{media.name}}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    {{media.description}} 
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group text-center">
                                    <template  v-if="media.content_type === 'image/jpeg' || media.content_type === 'image/png' || media.content_type === 'image/gif'">
                                        <img width="100%" :src="s3_url+media.path" alt="Maia Parsons" height="150px;">
                                    </template>
                                    <template  v-else-if="media.content_type === 'video/mp4'">
                                        <video width="100%" controls="controls" preload="metadata">
                                            <template  v-if="media.path != ''">
                                                <source :src="s3_url+media.path+'#t=0.5'"  type="video/mp4">
                                            </template>
                                            <template  v-else>
                                                <source src="" type="video/mp4">
                                            </template>
                                            </video>
                                    </template>
                                    <template  v-else>
                                        <a :href="s3_url+media.path" download>Download</a>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    </template>

                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    // ES6 Modules or TypeScript
    import Swal from 'sweetalert2';
    import {frontDomain,ssoDomain,s3_bucket_url} from '../../config'

    var moment = require('moment-timezone');

    export default {
        name: 'ClassDetails',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                s3_url:'https://vtemp-bucket.s3.us-west-2.amazonaws.com/',
                eventDetails : [],
                pageTitle : "Class Details",
                modelDataId : [],
                redirectFrom : "",
                showRegisterBtn : false,
            }
        },
        beforeMount: function () {
            self = this;

        },
        mounted: function () {
            // self.getClassDetailsById();
            self.s3_url = s3_bucket_url;
            if (self.redirectFrom === "calendar_view") {
                EventBus.$emit("menu-selection-changed", "calendarclass");

            } else {
                EventBus.$emit("menu-selection-changed", "listclassinfo");
            }
        },
        beforeDestroy(){

        },
        methods: {
            buttonBack : function() {
                if (self.redirectFrom === "calendar_view") {
                    self.$router.push({name : "ClassCalender"});
                } else if (self.redirectFrom === "search_view") {
                    self.$router.push({name : "ClassCalender"});
                } else {
                    self.$router.push({name : "ListClass"});
                }
            },
            cancelRegistration : function () {
                let userObj = JSON.parse(localStorage.getItem("user_obj"));
                if (self.redirectFrom === "calendar_view") {
                    var selectedDate = moment(new Date(self.modelDataId.start)).format("YYYY-MM-DD");
                } else if (self.redirectFrom === "search_view") {
                    //  var selectedDate = moment(new Date(self.modelDataId.start)).format("YYYY-MM-DD");
                    var selectedDate = moment(new Date(self.modelDataId.start_date_time)).format("YYYY-MM-DD");
                } else {
                    var  selectedDate = moment(new Date(self.modelDataId.row.event_date_time)).format("YYYY-MM-DD");
                }

                if (self.redirectFrom === "calendar_view") {
                    var fields = {
                        class_id: self.modelDataId.id,
                        user_id : userObj.id
                    };
                } else if (self.redirectFrom === "search_view") {
                    var fields = {
                        class_id: self.modelDataId.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                } else {
                    var fields = {
                        class_id: self.modelDataId.row.id,
                        user_id : userObj.id
                    };
                }

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to Cancel this class registration!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!'
                }).then((result) => {
                    if (result.value == true) {
                        HTTP.post('/class/cancelregister', fields, config).
                        then(response => {
                            if (response.data.status == "success") {
                                Swal.fire({
                                    type : "success",
                                    position: 'center',
                                    icon: 'success',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                EventBus.$emit("cancelRegistration","");
                                // Swal.fire('', response.data.message, 'success');
                                $('.close').click();
                                self.buttonBack();
                            }

                        })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    //self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        //self.$router.push("/login");
                                        self.$router.push({name : "Login"});
                                    }
                                    //self.error = err.response.data.message;
                                }
                            });
                    }
                });


            },

            registerToClass : function() {
                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                if (self.redirectFrom === "calendar_view") {
                    var selectedDate = moment(new Date(self.modelDataId.start)).format("YYYY-MM-DD");
                } else if (self.redirectFrom === "search_view") {
                    //  var selectedDate = moment(new Date(self.modelDataId.start)).format("YYYY-MM-DD");
                    var selectedDate = moment(new Date(self.modelDataId.start_date_time)).format("YYYY-MM-DD");
                }else {
                    var  selectedDate = moment(new Date(self.modelDataId.row.event_date_time)).format("YYYY-MM-DD");
                }

                if (self.redirectFrom === "calendar_view") {
                    var fields = {
                        class_id: self.modelDataId.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                } else if (self.redirectFrom === "search_view") {
                    var fields = {
                        class_id: self.modelDataId.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                } else {
                    var fields = {
                        class_id: self.modelDataId.row.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                }

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to register into this class!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!'
                }).then((result) => {
                    if (result.value == true) {
                        HTTP.post('/class/register', fields, config).
                        then(response => {
                            if (response.data.status == "success") {
                                Swal.fire({
                                    type : "success",
                                    position: 'center',
                                    icon: 'success',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                $('.close').click();
                                self.buttonBack();
                            }

                        })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    //self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        //self.$router.push("/login");
                                        self.$router.push({name : "Login"});
                                    }
                                    //self.error = err.response.data.message;
                                }
                            });
                    }
                })


            },
            getClassDetailsById: function (payload) {
                self.modelDataId = payload;
                let userObj = JSON.parse(localStorage.getItem("user_obj"));
                if (self.redirectFrom === "calendar_view") {
                    var selectedDate = moment(new Date(self.modelDataId.start)).format("YYYY-MM-DD");
                } else if (self.redirectFrom === "search_view") {
                    var  selectedDate = moment(new Date(self.modelDataId.start_date_time)).format("YYYY-MM-DD");
                } else if (self.redirectFrom === "attandent_class" || self.redirectFrom === "upcoming_class") {
                    var  selectedDate = moment(new Date(self.modelDataId.row.event_date)).format("YYYY-MM-DD");
                }

                if (self.redirectFrom === "calendar_view") {
                    var fields = {
                        class_id: self.modelDataId.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                } else if (self.redirectFrom === "search_view") {
                    var fields = {
                        class_id: self.modelDataId.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                } else  {
                    var fields = {
                        class_id: self.modelDataId.row.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                }

                self.showRegisterBtn = true;
                if (selectedDate != null && selectedDate != "" && typeof selectedDate != "undefined") {
                    if (selectedDate < moment(new Date()).format("YYYY-MM-DD")) {
                        self.showRegisterBtn = false;
                    } else {
                        self.showRegisterBtn = true;
                    }
                }

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/getmodeldata', fields, config).
                then(response => {
                    if (response.status == 200) {
                        $('#openModel').click();
                        self.eventDetails = response.data.content;

                        switch (self.eventDetails.week_day) {
                            case "1" :
                                self.eventDetails.week_day = "Monday";
                                break;
                            case "2" :
                                self.eventDetails.week_day = "Tuesday";
                                break;
                            case "3" :
                                self.eventDetails.week_day = "Wednesday";
                                break;
                            case "4" :
                                self.eventDetails.week_day = "Thursday";
                                break;
                            case "5" :
                                self.eventDetails.week_day = "Friday";
                                break;
                            case "6" :
                                self.eventDetails.week_day = "Saturday";
                                break;
                            case "7" :
                                self.eventDetails.week_day = "Sunday";
                                break;
                        }
                    }
                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                                self.$router.push({name : "Login"});
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
        }

    }
    EventBus.$on('CLASS_COMMON_PAGE', (payload, redirectFrom) => {
        self = this;
        if (typeof  self != "undefined") {
            /*self.$nextTick(function () {
                self.modelDataId = payload;
                self.redirectFrom = redirectFrom;
                self.getClassDetailsById(payload);
                if (self.redirectFrom === "calendar_view") {
                    EventBus.$emit("menu-selection-changed", "calendarclass");
                } else if (self.redirectFrom === "search_view") {
                    EventBus.$emit("menu-selection-changed", "calendarclass");
                } else {
                    EventBus.$emit("menu-selection-changed", "listclassinfo");
                }
            });*/

            setTimeout(function () {
                self.modelDataId = payload;
                self.redirectFrom = redirectFrom;
                self.getClassDetailsById(payload);
                if (self.redirectFrom === "calendar_view") {
                    EventBus.$emit("menu-selection-changed", "calendarclass");
                } else if (self.redirectFrom === "search_view") {
                    EventBus.$emit("menu-selection-changed", "calendarclass");
                } else {
                    EventBus.$emit("menu-selection-changed", "listclassinfo");
                }
            }, 200)
        }
    })

</script>



// WEBPACK FOOTER //
// src/components/CommonModelForClass/CommonClassDetailPage.vue